import { Address, RiskModel } from '@amfam/policy/models';

export interface KydSignUp {
  address: Address;
  riskModel: RiskModel;
}
